import Token from './token'
import Form from './form'

export default {
  svg: 'x',
  label: 'Set Variable',
  type: 'control',
  action: 'set',
  form: Form,
  token: Token
}
